module.exports = __webpack_public_path__ + "static/media/4_1.e8af6537.png";